<template>
  <div class="filebox">
    <label v-if="!previewImageFile.url" for="upload-img" class="img-upload-label">사진 등록</label>
    <input v-if="!previewImageFile.url" type="file" id="upload-img" accept="image/*"
           @change="(event) => previewImage(event)">
    <img v-if="previewImageFile.url" id="output" :src="previewImageFile.url"
         :alt="previewImageFile.name"/>
    <div v-if="previewImageFile.url" class="mask">
      <label for="upload-img" class="img-upload-label">사진 수정</label>
      <input type="file" id="upload-img" @change="(event) => previewImage(event)"
             accept="image/*"/>
    </div>
  </div>
  <ImageCropper :imageFile="imageFile" :maxWidth="maxWidth" :maxHeight="maxHeight" :isFixedSize="isFixedSize"
                @cropped="handleCroppedImage"/>
</template>

<script setup>
import {defineProps, ref} from 'vue'
import ImageCropper from "@/components/ui/ImageCropper.vue";

const props = defineProps({
  previewImageFile: Object,
});

const previewImageFile = ref(props.previewImageFile);
const selectedCropImageFile = ref(null);
const selectedOriginImageFile = ref(null);

const emit = defineEmits(['update:cropFile', 'update:originFile', 'update:cropImgUrl'])


const imageFile = ref(null);
const maxWidth = 193 * 5;
const maxHeight = 270 * 5;
let isFixedSize = false; // 이미지 크기 고정 여부(고정 하면 maxWidth, maxHeight size 로 파일 생성, 안하면 비율만 유지)

const previewImage = async (event) => {
  const fileInput = event.target; // file input element
  selectedOriginImageFile.value = fileInput.files[0];
  const file = fileInput.files[0];

  if (!file) {
    fileInput.value = "";
    return;
  }
  const maxFileSize = 10 * 1024 * 1024; // 10MB
  if (file.size > maxFileSize) {
    alert("파일 크기가 너무 큽니다. 10MB 이하의 파일만 업로드 가능합니다.");
    return;  // 용량 초과시 함수 종료
  }

  // 부모에서 이미지 파일만 전달
  imageFile.value = file;
  fileInput.value = "";
};

const handleCroppedImage = async (newVal) => {
  const {file, url, name} = newVal;
  previewImageFile.value = {url, name};
  selectedCropImageFile.value = file;
  emit('update:cropFile', selectedCropImageFile.value);
  emit('update:originFile', selectedOriginImageFile.value);
  emit('update:cropImgUrl', url);

};
</script>

<style scoped>
.filebox:hover .mask {
  opacity: 1;
}

.filebox .mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  opacity: 0;
  z-index: 1;
}

.img-upload-label {
  border-radius: 5px;
  background-color: #F7BE17;
  color: #151419;
  height: 36px;
}
</style>
